"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _config = require("webmotors-react-pj/config");
var _style = require("webmotors-react-pj/frame/header/logged/logo/style");
var _default = () => _react.default.createElement(_style.StyleLink, {
  href: "".concat(_config.UrlCockpit, "/")
}, _react.default.createElement(_style.StyleLogo, {
  src: "".concat(_config.UrlCockpit, "/assets/img/brands/cockpit.svg"),
  alt: "Logo Cockpit"
}));
exports.default = _default;